import { ConfigProvider, DatePicker } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { SOVEREIGN } from '../../../utils/epcProjectVisual';
import { DATE_DISPLAY_FORMAT } from '../format';
import { FieldLabel, HelperText } from '../ui';

const CAL_THEME = {
  token: {
    colorPrimary: SOVEREIGN.bottle,
    colorBgElevated: '#FCFBF6',
    colorText: SOVEREIGN.title,
    colorTextHeading: SOVEREIGN.title,
    colorTextPlaceholder: SOVEREIGN.kpiCaption,
    colorBorder: 'rgba(11,59,46,0.28)',
    colorSplit: 'rgba(11,59,46,0.14)',
    borderRadius: 12,
    controlItemBgActive: 'rgba(201,169,97,0.18)',
    fontFamily: 'inherit',
  },
  components: {
    DatePicker: {
      cellActiveWithRangeBg: 'rgba(51,146,116,0.12)',
      cellHoverBg: 'rgba(11,59,46,0.06)',
      activeBorderColor: SOVEREIGN.title,
      hoverBorderColor: 'rgba(51,146,116,0.6)',
      activeShadow: '0 0 0 3px rgba(166,206,57,0.22)',
      colorBgContainer: SOVEREIGN.inputBg,
      colorTextDisabled: 'rgba(124,138,130,0.5)',
    },
  },
} as const;

export default function SovereignDatePicker({
  id,
  label,
  value,
  onChange,
  hint,
  warn,
  required,
  minDate,
}: {
  id: string;
  label: string;
  /** 'YYYY-MM-DD' or '' */
  value: string;
  onChange: (v: string) => void;
  hint?: string;
  warn?: string;
  required?: boolean;
  /** 'YYYY-MM-DD' — days before this are disabled. */
  minDate?: string;
}) {
  const parsed = value ? dayjs(value, 'YYYY-MM-DD') : null;
  const min = minDate ? dayjs(minDate, 'YYYY-MM-DD') : null;
  return (
    <div>
      <FieldLabel hint={required ? 'Required' : hint ? undefined : 'Optional'}>{label}</FieldLabel>
      <ConfigProvider theme={CAL_THEME}>
        <DatePicker
          id={id}
          size="large"
          className="w-full"
          format={DATE_DISPLAY_FORMAT}
          placeholder={DATE_DISPLAY_FORMAT.toLowerCase()}
          value={parsed?.isValid() ? parsed : null}
          onChange={(d: Dayjs | null) => onChange(d ? d.format('YYYY-MM-DD') : '')}
          disabledDate={min ? (d: Dayjs) => d.isBefore(min, 'day') : undefined}
          status={warn ? 'warning' : undefined}
          style={{ borderRadius: 12 }}
        />
      </ConfigProvider>
      {warn ? <HelperText tone="warn">{warn}</HelperText> : hint ? <HelperText>{hint}</HelperText> : null}
    </div>
  );
}
